export default {"src":"/_next/static/media/Content-5.c28da961.svg","height":441,"width":712};